export default function validation(message, messages) {
  if (message.indexOf('GAP_BETWEEN_BUYING_RANGES') !== -1) {
    const params = message.split('|')[0].split('@');
    messages.push({
      message: 'catalogue.validation.GapBetweenBuyingRanges',
      parametres: {
        montantHaut: params[1].split(' ')[0],
        montantBas: params[2].split(' ')[0],
        dateDebut: params[3].split(' ')[0],
        dateFin: params[4].split(' ')[0],
      },
    });
  }
  if (message.indexOf('BUYING_RANGES_SHOULD_START_AT_0') !== -1) {
    const params = message.split('|')[0].split('@');
    messages.push({
      message: 'catalogue.validation.trancheAchatShouldStartAt0',
      parametres: {
        montantBas: params[1].split(' ')[0],
        dateDebut: params[2].split(' ')[0],
        dateFin: params[3].split(' ')[0],
      },
    });
  }
  if (message.indexOf('LOW_AMOUNT_GREATER_HIGH_AMOUNT') !== -1) {
    const params = message.split('|')[0].split('@');
    messages.push({
      message: 'catalogue.validation.trancheAchatLowAmountGreaterHighAmount',
      parametres: {
        dateDebut: params[1].split(' ')[0],
        dateFin: params[2].split(' ')[0],
        montantBas: params[3].split(' ')[0],
        montantHaut: params[4].split(' ')[0],
      },
    });
  }
  if (message.indexOf('PAYOUT_AMOUNT_REQUIRED_IF_FIXED_AMOUNT') === 0) {
    const splitMessage = message.split('|')[0].split('@');
    messages.push({
      message: 'catalogue.validation.reglesAchat.payoutAmountRequiredIfFixedAmount',
      parametres: {
        debut: splitMessage[1],
        fin: splitMessage[2],
      },
    });
  }
  if (message.indexOf('PAYOUT_PERCENTAGE_REQUIRED_IF_FIXED_PERCENTAGE') === 0) {
    const splitMessage = message.split('|')[0].split('@');
    messages.push({
      message: 'catalogue.validation.reglesAchat.payoutPercentageRequiredIfFixedPercentage',
      parametres: {
        debut: splitMessage[1],
        fin: splitMessage[2],
      },
    });
  }
  if (message.indexOf('DATES_OVERLAP_FOR_BUYING_RULE') !== -1) {
    const dates = message.split('|')[0].split('@');
    messages.push({
      message: 'catalogue.validation.regleAchatDateOverlap',
      parametres: {
        dateDebut: dates[1].split(' ')[0],
        dateFin: dates[2].split(' ')[0],
      },
    });
  }
  if (message.indexOf('AMOUNTS_OVERLAP_FOR_BUYING_RANGE') !== -1) {
    messages.push({
      message: 'catalogue.validation.amountTrancheOverlap',
    });
  }
  if (message.indexOf('PAYOUT_PERCENTAGE_REQUIRED_IF_GUARANTEED_REVENUE_SELECTED') === 0) {
    const splitMessage = message.split('|')[0].split('@');
    messages.push({
      message: 'catalogue.validation.reglesAchat.payoutPercentageRequiredIfGuaranteedRevenueSelected',
      parametres: {
        debut: splitMessage[1],
        fin: splitMessage[2],
      },
    });
  }
  if (message.indexOf('ONLY_ONE_OF_GUARANTEED_FIELDS_ALLOWED') === 0) {
    const splitMessage = message.split('|')[0].split('@');
    messages.push({
      message: 'catalogue.validation.reglesAchat.onlyOneOfGuaranteedFieldsAllowed',
      parametres: {
        debut: splitMessage[1],
        fin: splitMessage[2],
      },
    });
  }
}
